import React, { FunctionComponent, useContext, useEffect } from 'react'
import { View } from 'react-native'

import { useScript } from '@lyrahealth-inc/shared-app-logic/src/features/common/hooks/useScript'
import { DEFAULT_LANGUAGE } from '@lyrahealth-inc/shared-app-logic/src/features/intl/constants'

import { ProductTypeContext } from '../../utils/productType/productTypeContext'
import { tID } from '../../utils/utils'

export interface EssentialsHomepageWidgetProps {
  language: string
}

export const EssentialsHomepageWidget: FunctionComponent<EssentialsHomepageWidgetProps> = ({ language }) => {
  const { essentialsTheme } = useContext(ProductTypeContext)
  const scriptStatus = useScript(
    'https://lyra-essentials-widgets.bukwild.com/essentials-homepage-widget.js',
    false,
    undefined,
  )

  useEffect(() => {
    if (scriptStatus === 'ready') {
      const existingHomepage = document.querySelector('.widget.essentials-homepage')
      if (existingHomepage) {
        existingHomepage.remove()
      }

      const divElement = document.createElement('div')
      divElement.setAttribute('data-essentials-homepage-widget', '')
      divElement.setAttribute('data-locale', language === DEFAULT_LANGUAGE ? 'en' : language.toLowerCase())
      divElement.setAttribute('data-theme', essentialsTheme ?? 'wfmh')
      document.querySelector('[data-testid="EssentialsHomepageWidgetContainer"]')!.appendChild(divElement)
      window.EssentialsHomepageWidget.mount('[data-essentials-homepage-widget]')
    }
  }, [scriptStatus, language, essentialsTheme])

  return <View testID={tID('EssentialsHomepageWidgetContainer')} />
}
